import Ifrs9Layout from '@/modules/ifrs9/layout/IFRS9Layout.vue';

const routes = [
  {
    path: 'dashboard',
    name: "Dashboard",
    component: () => import('@/modules/ifrs9/views/Dashboard.vue')
  },
  {
    path: "report/:reportId/report_type/:reportType",
    name: "Report Details",
    component: () => import('@/modules/ifrs9/views/Report.vue')
  },
  {
    path: "downloads",
    name: "Report Center",
    component: () => import('@/modules/ifrs9/views/ReportCenter.vue')
  },
  {
    path: "uploads",
    name: "UploadCenter",
    component: () => import('@/modules/ifrs9/views/UploadCenter.vue')
  },
  {
    path: "general-settings",
    name: "General Settings",
    component: () => import('@/modules/ifrs9/views/GeneralSettings.vue')
  },
  {
    path: "ifrs9-settings",
    name: "IFRS9 Settings",
    component: () => import('@/modules/ifrs9/views/IFRS9Settings.vue')
  },
];

export default {
  path: 'ifrs9',
  name: 'ifrs9',
  component: Ifrs9Layout,
  redirect: {
    name: 'Dashboard'
  },
  meta: {
    requiresAuth: true
  },
  children: [...routes]
};